<template>
  <q-item-label
    class="text-caption text-grey-7"
  >
    SMS notifications cost $0.07 per 160-characters.
    Total usage charges can be found on your subscription invoice.
  </q-item-label>
</template>
